<section *ngIf="post" class="landing-page-url">
  <h3>
    {{ "brand.campaign.landingPageUrl.title" | translate }}
    @if (platform !== LinkedIn) {
      <app-tooltip
        text="{{ 'brand.campaign.landingPageUrl.tooltip' | translate }}"
      />
    } @else {
      <app-tooltip
        text="{{ 'brand.campaign.landingPageUrl.linkedInTooltip' | translate }}"
      />
    }
  </h3>

  <div class="row">
    <div class="col">
      <mat-form-field class="post-content">
        <mat-label>{{
          post.link
            ? ""
            : ("brand.campaign.landingPageUrl.placeholder" | translate)
        }}</mat-label>
        <input
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"
          #postLinkField="ngModel"
          [(ngModel)]="post.link"
          id="post-link"
          name="post-link"
          type="text"
          tabindex="-1"
          required
          pattern="{{ landingPageUrlValidationPattern }}"
        />
        <mat-error
          class="email-error"
          *ngIf="postLinkField.errors && postLinkField.errors['required']"
        >
          {{ "brand.campaign.landingPageUrl.typeContentRequired" | translate }}
        </mat-error>
        <mat-error
          class="email-error"
          *ngIf="postLinkField.errors && postLinkField.errors['pattern']"
        >
          {{ "shared.enterValidUrl" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</section>
